module.exports = __webpack_public_path__ + "img/block-2-img.627122f0.png";